export const HOURS_24 = 60 * 60 * 24; // 24 hours in seconds
export const PAGE_TITLE_SUFFIX = ' • ';
export const DEFAULT_COMPRESSOR_TYPE = 'llm_compressor';

export const CUSTOM_PROJECTS_ID = {
  // Dev TODO
  hkinvest_dev: '151e91d7-c077-4d73-82d9-1947c11d4f7d',

  // Staging
  hkinvest_staging: 'f4e6b5c2-3f58-44c4-a134-cd3ea1e2a897',

  // Prod
  hkinvest_prod: {
    fr: '7262d278-b329-4283-bf72-dd44b77e177b',
    uk: '635d5e52-c63b-40c0-9089-db48000eb28d',
    uae: '5a861690-5978-4add-915a-7e550b5cfec1',
  },

  monolith: '200780a6-c059-4a02-bf4a-d27afd0369bb',

  // Staging
  directassurance: 'ab7671e6-fc53-4ee4-a2e3-b61eb9195e3d',

  // dev alcyon david
  alcyon: '901561fa-2979-460f-a853-8c57f2deb3f6',
};

export const CUSTOM_STYLES_ORGANIZATIONS_ID = {
  oddo_bhf: 'oddo-bhf-7e30765d0916b0c80a4120a2bd5',
  garance: 'garance-cb20ca10a650cf43b7d5b56ecf16',
  adx: 'adx-f5f0fd1548227b5b680e9bfbd4afde06',
};

// MED-6911 — projects whose overlay chat trigger shows a custom label
// ("Posez vos questions ici") instead of the default "chatWithAiAboutDocument".
// TODO(MED-6911): temporary per-project override — remove this whole map once
// the customer has validated the custom chat label.
export const CUSTOM_CHAT_LABEL_PROJECTS_ID = {
  posezVosQuestions: '637e5804-21da-494e-8d5e-db826cb92c2e',
  // Local testing only
  localTest: '35695b2b-2bc1-47b8-9190-73b9770f09a7',
};

export const MULTIPLE_DOCS_DISPLAY = false;
export const AUTO_REDIRECT_PRETTY_ROUTES = false;
export const PDF_HIGHLIGHTS_SMOOTH_SCROLL_MAX_PAGE_DISTANCE = 2;

export const PIN_BY_EMAIL_TOKEN_COOKIE = `pub_pin_token`;
export const ACCESS_REQUEST_KEY = `pub_access_request`;

// Presence of this message in the x-error-message header indicates that
// we need to show the Request access form to the user
export const PIN_BY_EMAIL_ERROR_MESSAGE = 'Bearer token is required';

export const APP_PREFIX = 'libertify';
